import React from 'react';

interface ISkillsTab {
  isHighlightHit: (item: string) => boolean;
  skills?: string[];
  matchedSkills?: string[];
  behavioralAttributes?: string[];
  matchedBehavior?: string[];
}
export const SkillsTab = (props: ISkillsTab) => {
  const {
    isHighlightHit,
    skills,
    matchedSkills,
    behavioralAttributes,
    matchedBehavior,
  } = props;
  return (
    <div className='py-2'>
      <div className='space-y-4 animate-fadeIn'>
        { /* All Skills */ }
        <section>
          <h3 className='text-sm font-bold text-gray-800 mb-3 flex items-center'>
            <span className='w-1 h-4 bg-gradient-to-b from-green-500 to-emerald-500 rounded-full mr-2'></span>
            All Skills
          </h3>
          <div className='flex flex-wrap gap-1.5 p-2 bg-gray-50 rounded-lg border border-gray-200'>
            { skills?.length ? (
              skills.map((skill, i) => (
                <span
                    key={i}
                    className={`px-2.5 py-1 text-xs font-medium rounded-lg transition-all duration-200 ${
                      isHighlightHit(skill)
                        ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-sm ring-2 ring-green-200'
                        : 'bg-white text-gray-700 border border-gray-300 hover:border-gray-400'
                    }`}
                >
                  { skill }
                </span>
              ))
            ) : (
              <p className='text-gray-500 text-xs'>No skills available</p>
            ) }
          </div>
        </section>

        { /* Matched Skills */ }
        <section>
          <h3 className='text-sm font-bold text-gray-800 mb-3 flex items-center'>
            <span className='w-1 h-4 bg-gradient-to-b from-green-500 to-emerald-500 rounded-full mr-2'></span>
            Matched Skills
          </h3>
          <div className='flex flex-wrap gap-1.5 p-3 bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg border border-green-200'>
            { matchedSkills?.length ? (
              matchedSkills.map((skill, i) => (
                <span
                    key={i}
                    className='px-2.5 py-1 text-xs font-semibold bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-lg shadow-sm'
                >
                  { skill }
                </span>
              ))
            ) : (
              <p className='text-gray-500 text-xs'>
                No matched skills available
              </p>
            ) }
          </div>
        </section>

        { /* Behavioral Attributes */ }
        <section>
          <h3 className='text-sm font-bold text-gray-800 mb-3 flex items-center'>
            <span className='w-1 h-4 bg-gradient-to-b from-orange-500 to-red-500 rounded-full mr-2'></span>
            Behavioral Attributes
          </h3>
          <div className='flex flex-wrap gap-1.5 p-2 bg-gray-50 rounded-lg border border-gray-200'>
            { behavioralAttributes?.length ? (
              behavioralAttributes.map((attribute, i) => (
                <span
                    key={i}
                    className={`px-2.5 py-1 text-xs font-medium rounded-lg transition-all duration-200 ${
                      isHighlightHit(attribute)
                        ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-sm ring-2 ring-orange-200'
                        : 'bg-white text-gray-700 border border-gray-300 hover:border-gray-400'
                    }`}
                >
                  { attribute }
                </span>
              ))
            ) : (
              <p className='text-gray-500 text-xs'>
                No behavioral attributes available
              </p>
            ) }
          </div>
        </section>

        { /* Matched Behavioral Attributes */ }
        <section>
          <h3 className='text-sm font-bold text-gray-800 mb-3 flex items-center'>
            <span className='w-1 h-4 bg-gradient-to-b from-orange-500 to-red-500 rounded-full mr-2'></span>
            Matched Behavioral Attributes
          </h3>
          <div className='flex flex-wrap gap-1.5 p-3 bg-gradient-to-br from-orange-50 to-red-50 rounded-lg border border-orange-200'>
            { matchedBehavior?.length ? (
              matchedBehavior.map((skill, i) => (
                <span
                    key={i}
                    className='px-2.5 py-1 text-xs font-semibold bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg shadow-sm'
                >
                  { skill }
                </span>
              ))
            ) : (
              <p className='text-gray-500 text-xs'>
                No matched behavioral attributes available
              </p>
            ) }
          </div>
        </section>
      </div>
    </div>
  );
};
